import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { OPTIONS_AND_ACCESSORIES } from 'build-and-quote/constants/sections.js';
import * as Actions from 'build-and-quote/actions/buildAndQuoteActions.js';
import Options from 'build-and-quote/components/OptionsAccessories/Options.jsx';

function mapStateToProps(state) {
    const currentSection = state.buildAndQuote.buildAndQuoteSection;
    const selectedOptionsPackage = state.modelYear.getSelectedOptionsPackage();
    const { purchaseMethods, modelYear, quote } = state;
    const isOpened = currentSection === OPTIONS_AND_ACCESSORIES.value;
    const options = isOpened && selectedOptionsPackage ? selectedOptionsPackage.configuration.options : [];
    const isLease = purchaseMethods.lease.selected;
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    const { taxesFactor } = purchaseMethods;
    const taxCodes = purchaseMethods.getTaxCodesString();
    const paymentFrequencyLabel = purchaseMethods.getPaymentFrequencyLabels(false, LocaleService).perPeriod;

    const selectedModel = {
        bodyStyleCode: modelYear.bodyStyleCode,
        isSingleConfiguration: modelYear.isSingleConfiguration,
        hasOptions: modelYear.hasOptions,
        year: modelYear.year,
        make: modelYear.make,
        model: modelYear.model,
    };

    return {
        isOpened,
        currentSection,
        selectedModel,
        isLease,
        selectedFinanceTerm,
        paymentFrequencyLabel,
        quote,
        taxesFactor,
        taxCodes,
        options,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Options);
